import joi from 'joi';
import moment from 'moment';
import { Record as record } from 'immutable';

import { translate as t } from '../../lib/I18n';
import validation from '../../validation';
import ValidationMixin from '../ValidationMixin';
import Address from '../../records/customer/Address';

const defaults = {
    cardHolderName: '',
    cardNumber: '',
    expiryMonth: 0,
    expiryYear: 0,
    cv2: '',
    addressLine1: '',
    addressLine2: '',
    addressLine3: '',
    townCity: '',
    postcode: '',
    country: 'GBR',
    store: false,
    nickname: null,
    storedCard: null
};


class CardForm extends record(defaults) {

    static fromJSON (json = {}) {
        return new CardForm(json);
    }

    getComputedValues () {
        // momentjs is creating dates from invalid strings like `01-Expiry year`
        const expiryMonth = parseInt(this.expiryMonth, 10);
        const expiryYear = parseInt(this.expiryYear, 10);
        const isExpired = moment().isAfter(moment(`${expiryMonth}-${expiryYear}`, 'MM-YYYY').endOf('month'));

        return {
            isExpired: Boolean(expiryMonth) && Boolean(expiryYear) && isExpired
        };
    }

    getSchema () {
        if (this.storedCard) {
            return {
                storedCard: joi.any(),
                cv2: validation.cv2()
            };
        }

        return {
            cardHolderName: validation.cardHolderName(),
            cardNumber: validation.cardNumber(),
            expiryMonth: validation.expiryMonth(),
            expiryYear: validation.expiryYear(),
            cv2: validation.cv2(),
            store: joi.boolean(),
            nickname: joi.any().when('store', {
                is: true,
                then: validation.name(1, 20),
                otherwise: joi.any()
            }),
            addressLine1: validation.addressLine().required(),
            addressLine2: validation.textMaxLength(),
            addressLine3: validation.textMaxLength(),
            townCity: validation.townCity(),
            postcode: joi.any().when('country', {
                is: defaults.country,
                then: validation.postcode(),
                otherwise: validation.optional()
            }),
            country: validation.country(),
            isExpired: joi.any().valid(false).messages({
                'any.only': t('alertmessage.cardExpired'),
            })
        };
    }

    getAddress () {
        return new Address({
            line1: this.addressLine1,
            line2: this.addressLine2,
            line3: this.addressLine3,
            town: this.townCity,
            postCode: this.postcode,
            country: this.country
        });
    }

    debugPrint() {
        return [this.addressLine1, this.addressLine2, this.addressLine3, this.townCity, this.postcode, this.country].join(', ');
    }

    setAddress (address) {
        return this.merge({
            addressLine1: address.line1,
            addressLine2: address.line2,
            addressLine3: address.line3,
            townCity: address.town,
            postcode: address.postCode,
            country: address.country
        });
    }
}


Object.assign(CardForm.prototype, ValidationMixin);


export default CardForm;
